import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  ActiveTestQueuedStateService,
  AgentDownloadDialogService,
  BenchmarkService,
  CommonDialogComponent,
  Device,
  DevicesService,
  DialogService,
  IDeviceData,
  NotificationService,
  Site,
  TabulatorService,
  UserAuth,
  UtilsService,
  ValuesExchangeProvider,
  WindowRef,
  UserService,
  FusionTransformationService,
  FUSION_AGENT_ACTION_NAME,
  AGENT_MODEL,
  REFLECTOR_TYPE,
  TestTypeValue,
  LicensesPageService,
  TestListService
} from '@nrwl/common-lib';
import { NavigationProvider } from '@nrwl/navigation-abstract';
import { filter, find, forEach, get, isArray, isEmpty, map, isEqual } from 'lodash';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ViaviTableComponent } from '../../../../../viavi-tabulator/src/lib/component/viavi-table/viavi-table.component';
import { DataSourceService } from '../../service/datatsource.service';
import { AddUnmanagedDeviceComponent } from '../unmanaged-devices/add-unmanaged-device/add-unmanaged-device.component';
import { ImportDevicesComponent } from '../unmanaged-devices/import.devices/import.devices.component';
import { UnmanagedDeviceListComponent } from '../unmanaged-devices/unmanaged-device-list/unmanaged-device-list.component';

import {
  ITextIconLabel,
  LAST_UPGRADE_MESSAGE,
  SUB_STATUS,
  UPGRADE_DISPLAY_MESSAGE
} from './models/types';
import { EditManagedDeviceComponent } from '../managed-devices/edit-managed-device/edit-managed-device.component';
import { AgentSpecComponent } from '../managed-devices/agent-spec/agent-spec.component';
import { JmepConfigureManagementComponent } from '../jmep/configure/jmep-configure-management/jmep-configure-management.component';
import { JmepV2ConfigureManagementComponent } from '../jmep/configure/jmepv2-configure-management/jmepv2-configure-management.component';
import { JmepConfigureService } from '../../service/jmep-configure.service';
import { JmepDiscoverDialogComponent } from '../jmep/discover/jmep-discover-dialog/jmep-discover-dialog.component';
import { ControllerApiService } from '@nrwl/test-setup';
import { TrafficResultsComponent } from '../traffic-results/traffic-results.component';
import { TransferDeviceComponent } from '../transfer-device/transfer-device.component';
import { AlarmsDialogComponent } from '../managed-devices/alarms-dialog/alarms-dialog.component';

export enum DataSource {
  GIGA_TEST = 'GigaTestAgent'
}

export enum DataSourceState {
  ENABLED = 'enabled',
  DISABLED = 'disabled'
}

//Upgrade applicable only greater than this version
export const UPGRADE_AVAILABLE_HARDWARE_VERSION = '4.0.0.0-0';
export const UPGRADE_AVAILABLE_VQT_VERSION = '4.0.0.0-0';
export const UPGRADE_AVAILABLE_MAP2100_VERSION = '32.9.9';
@Component({
  selector: 'nrwl-datasource-entity',
  templateUrl: './datasource.entity.component.html',
  styleUrls: ['./datasource.entity.component.scss']
})
export class DatasourceEntityComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(ViaviTableComponent) child: ViaviTableComponent;
  @ViewChild(UnmanagedDeviceListComponent) unmanChild: UnmanagedDeviceListComponent;

  onTableFiltered: (click) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataSource: Subject<any>;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 50];
  showPaginator: BehaviorSubject<boolean>;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onTableRowClick: Function;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentDataSource: any = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataSourceTableData: any = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataSourceDetails: any = [];
  title: string;
  dataSourceNameImg = 'images/agents-bp.svg';
  registrationTime = 'firstRegistrationTime';
  lastRegistrationTime = 'lastRegistrationTime';
  platform = 'platform';
  version = 'version';
  // eslint-disable-next-line
  proxyUrl: string;
  serverConfig = null;
  deviceList: Array<Device>;
  deviceAvailable = false;
  // eslint-disable-next-line
  dialogRef: MatDialogRef<CommonDialogComponent>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unManaggedDeviceData: any;
  addDeviceDialogRef: MatDialogRef<AddUnmanagedDeviceComponent>;
  editDeviceDialogRef: MatDialogRef<EditManagedDeviceComponent>;
  jmepConfigureDialogRef: MatDialogRef<JmepConfigureManagementComponent>;
  jmepV2ConfigureDialogRef: MatDialogRef<JmepV2ConfigureManagementComponent>;
  jmepDiscoverDialogRef: MatDialogRef<JmepDiscoverDialogComponent>;
  jmepTransferDialogRef: MatDialogRef<TransferDeviceComponent>;
  selectedFilter = '';
  refreshTable: BehaviorSubject<boolean>;
  refreshApplications: BehaviorSubject<boolean>;
  sitesData: Array<Site>;
  hasReadWriteRole = false;
  isLoading = false;
  deviceDataSource: Array<Device>;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  prevDeviceData: any = [];
  CallHomeUrl: string;
  resetCheckbox: Subject<string[]>;
  exportUnmanagedDevice: Subject<boolean>;
  deviceWithMonitors = [];
  availableFirmwareVersion = {};
  availableJmepVersions = null;
  selectedAgentAvailableVersion = {};
  minoURL = {
    [AGENT_MODEL.VQT]: null,
    [AGENT_MODEL.HARDWARE]: null
  };
  timeInterval = {
    oneDay: 86400000,
    fiveMinutes: 300000
  };
  // eslint-disable-next-line
  table: any;
  agentDownloadOptionVisibility = false;
  agentControlProxySelectionWindow = false;
  tabName: string;
  nestedTabName = 'Managed';
  loadNewData: boolean;
  isAtweb: boolean;
  isFusionUI: boolean;
  isPmTestEnabled = false;
  esamFiltered = false;
  selectedEsamName: string;
  selectedEsamItem: any;
  maxBulkRemoveLimit = 2000;
  previousAgentFilter = [];
  currentTableDatasource = [];
  selectedFilterItem = 'total';
  deviceCounters = [
    {
      id: 'total',
      label: 'FOUND',
      count: 0,
      selected: true,
      class: ''
    },
    {
      id: 'idle',
      label: 'IDLE',
      count: 0,
      selected: false,
      class: 'green'
    },
    {
      id: 'running',
      label: 'RUNNING',
      count: 0,
      selected: false,
      class: 'green'
    },
    {
      id: 'online',
      label: 'ONLINE',
      count: 0,
      selected: false,
      class: 'green'
    },
    {
      id: 'offline',
      label: 'OFFLINE',
      count: 0,
      selected: false,
      class: 'red'
    }
  ];
  selectedNestedTabIndex = 0;
  timeoutId: any;
  isTrafficResultsLicenseEnabled = false;
  firmwareTimeout: any;
  vspaVariants = [
    AGENT_MODEL.VSPA_PM,
    AGENT_MODEL.VSPA_PM_L,
    AGENT_MODEL.VSPA_SAT,
    AGENT_MODEL.VSPA_SAT_LB,
    AGENT_MODEL.VSPA_SAT_TS
  ];
  enableForceOption = false;
  private readonly unsubscribe: Subject<void> = new Subject();
  private cacheObj: Subscription;
  // eslint-disable-next-line
  importDialogRef: MatDialogRef<any>;
  constructor(
    private readonly dataSourceService: DataSourceService,
    private readonly userAuth: UserAuth,
    readonly agentDownloadService: AgentDownloadDialogService,
    private readonly transformService: FusionTransformationService,
    private readonly window: WindowRef,
    private readonly notificationService: NotificationService,
    private readonly testListService: TestListService,
    private readonly deviceService: DevicesService,
    private readonly valuesExchangeProvider: ValuesExchangeProvider,
    private readonly utilService: UtilsService,
    private readonly navigator: NavigationProvider,
    private readonly dialogService: DialogService,
    private dialog: MatDialog,
    private readonly tabulatorService: TabulatorService,
    private readonly benchmarkService: BenchmarkService,
    private readonly queuedService: ActiveTestQueuedStateService,
    private readonly userService: UserService,
    private readonly jmepConfigureService: JmepConfigureService,
    private controllerApiService: ControllerApiService,
    private _changeDetectorRef: ChangeDetectorRef,
    private licenseService: LicensesPageService,
    @Inject('environments') environments: any //eslint-disable-line
  ) {
    this.benchmarkService.registerPageEvent('dataSourcePageRendering');
    this.onTableRowClick = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.onTableFiltered = null;
    this.dataSource = new BehaviorSubject<any>(null);
    this.resetCheckbox = new Subject<string[]>();
    this.exportUnmanagedDevice = new Subject<boolean>();
    this.showPaginator = new BehaviorSubject<boolean>(true);
    this.CallHomeUrl = environments?.EnvKeys?.CallHomeUrl;
    this.dialog = dialog;
    this.table = this.tabulatorService.commonTableConfiguration();
    this.table.groupHeader = this.tabulatorService.groupHeader;
    this.table.dataTree = true;
    this.table.dataTreeFilter = true;
    this.table.dataTreeStartExpanded = false;
    this.table.dataTreeSelectPropagate = true;
    this.table.height = this.window.nativeWindow.innerHeight - 333 + 'px';
    this.table.rowHeight = 40;
    this.table.initialSort = [{ column: 'name.label', dir: 'asc' }];
    this.tabName = null;
    this.table.columnDefaults = {
      title: 'test',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      tooltip: (event, cell, onRendered) => {
        if (!cell.getRow().isSelected()) {
          const theme = sessionStorage.getItem('theme') === 'dark' ? 'dark-theme' : '';
          const cellData = cell.getRow().getData()['version'];

          const elParent = document.createElement('div');
          elParent.id = 'tabulator-custom-tooltip';
          elParent.className = `icon-text-wrapper ${theme}`;
          const el = document.createElement('div');
          el.className = 'tabulator-tooltip main-title';
          el.innerText = event.target.innerText;
          elParent.appendChild(el);
          if (el.innerText === '' || el.innerText === '-') return;
          if (el.innerText === 'upgrade available') return cellData.upgradeInfo;
          if (el.innerText === 'update available') return cellData.upgradeInfo;

          return elParent;
        } else {
          return;
        }
      }
    };
    this.table.persistenceID = 'device-management';
    this.loadNewData = false;
    this.refreshTable = new BehaviorSubject<boolean>(false);
    this.refreshApplications = new BehaviorSubject<boolean>(false);
  }

  ngOnInit() {
    this.deviceService
      .getDevices$()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.deviceList = res.data;
      });
    if (!this.serverConfig) {
      this.getServerConfig();
    }
    if (this.userService.isFusionUIProject()) {
      this.platform = 'model';
      this.isFusionUI = true;
    } else {
      this.isAtweb = false;
      this.isFusionUI = false;
    }

    this.isLoading = true;
    this.populateDeviceData();
    this.title = 'Device management';
    this.valuesExchangeProvider.registerInterest(
      'onDatasourceUpdated',
      this.onDatasourceUpdated.bind(this)
    );
    this.updateReadWriteRoleInfo();

    this.onTableRowClick = data => {
      const testType = data.type?.name;
      if (testType?.includes('ESAM')) {
        this.showConfiguredJmeps(data);
      }
    };

    this.onTableFiltered = filter => {
      if (filter) {
        const data = this.child.table.getHeaderFilters().length
          ? this.child.filteredItems()
          : this.currentTableDatasource;
        if (!isEmpty(data)) {
          this.deviceCounters[0].count = data.length;
          this.deviceCounters[1].count = data.filter(
            device =>
              device.dataItem.activity?.status === 'idle' &&
              device.dataItem.activity?.p1?.status !== 'running' &&
              device.dataItem.activity?.p2?.status !== 'running'
          ).length;
          this.deviceCounters[2].count = data.filter(
            device =>
              device.dataItem.activity?.status === 'running' ||
              device.dataItem.activity?.p1?.status === 'running' ||
              device.dataItem.activity?.p2?.status === 'running'
          ).length;
          this.deviceCounters[3].count = data.filter(item => item.status === 'online').length;
          this.deviceCounters[4].count = data.filter(item => item.status === 'offline').length;
        }
      }
    };

    this.licenseService.activeTestLicenseDetails.subscribe(licenseData => {
      if (licenseData?.length) {
        this.isTrafficResultsLicenseEnabled = licenseData.some(
          o => o.featureName === 'EAX-TMON-JMEP'
        );
        this.licenseService.setJmepTrafficLicense(this.isTrafficResultsLicenseEnabled);
      }
    });
  }

  ngAfterViewInit() {
    this.deviceAvailable = true;
  }

  ngOnDestroy() {
    if (this.cacheObj) {
      this.cacheObj.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.agentDownloadService.closeDialog();
    if (this.timeoutId) clearTimeout(this.timeoutId);
    if (this.firmwareTimeout) clearTimeout(this.firmwareTimeout);
  }

  refreshManagedDeviceList(): void {
    this.isLoading = true;
    this.testListService.updateTestLists(this.testListService.getTestLists());
    this.deviceService.updateCache();
  }

  refreshTabsData(): void {
    if (this.tabName === 'Applications') {
      this.refreshApplicationPage();
    } else if (this.nestedTabName === 'Managed') {
      this.refreshManagedDeviceList();
    } else if (this.nestedTabName === 'Unmanaged') {
      this.refreshUnmanagedDevices();
    }
  }

  getServerConfig(): void {
    this.controllerApiService
      .getServerConfig()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.serverConfig = response.data;
        this.checkIsPmTestEnabled();
      });
  }

  checkIsPmTestEnabled(): void {
    if (this.serverConfig) {
      this.isPmTestEnabled = this.serverConfig?.['fusion-activepmtest']?.['enabled'];
    }
  }

  getLatestFirmwareVersion(): void {
    this.deviceService
      .getFirmwareValues()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.isLoading = false;
        let hasChanged = false;
        if (response) {
          const agentLinks = response?.latestFirmwareImages;
          if (agentLinks) {
            hasChanged = !isEqual(agentLinks, this.availableFirmwareVersion);
            if (this.firmwareTimeout) clearTimeout(this.firmwareTimeout);
            this.availableFirmwareVersion = { ...agentLinks };
            const vspaLinks = agentLinks[AGENT_MODEL.VSPA];
            //adding vspa links for all model type
            if (vspaLinks) {
              for (const model of this.vspaVariants) {
                this.availableFirmwareVersion[model] = vspaLinks;
              }
            }
          } else {
            this.firmwareTimeout = setTimeout(() => {
              this.getLatestFirmwareVersion();
            }, 500);
          }
          if (hasChanged) {
            this.getTranformedData$();
          }
        }
      });
  }

  async getjmepImagesList(): Promise<any> {
    try {
      const response = await this.dataSourceService
        .getjmepImagesList()
        .pipe(takeUntil(this.unsubscribe))
        .toPromise();
      if (response.status === 'success' && response?.files?.length) {
        this.availableJmepVersions = response.files.map(item => this.transformJmepImagesList(item));
      }
    } catch (e) {
      return null;
    }
  }

  transformJmepImagesList(item: string): any {
    return {
      image: item,
      version: item.split('_')[1].split('.pkg')[0],
      url: ''
    };
  }

  getProxyInfo(): void {
    this.dataSourceService
      .getProxy()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response && response[0]) {
            this.proxyUrl =
              'Agent control proxy: https://' + response[0].proxyServer + ':' + response[0].port;
          } else {
            this.proxyUrl = '';
          }
        },
        () => {
          this.proxyUrl = '';
        }
      );
  }

  // eslint-disable-next-line
  changeTab(event: any): void {
    if (event.tab.textLabel === 'Applications') {
      this.tabName = 'Applications';
    } else if (event.tab.textLabel === 'Devices') {
      this.tabName = 'Devices';
      this.nestedTabName = 'Managed';
      this.selectedNestedTabIndex = 0;
      this.deviceAvailable = false;
      this.assignData();
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.deviceAvailable = true;
      }, 1);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  nestedTabchange(event: any): void {
    this.nestedTabName = event.tab.textLabel;
    if (this.nestedTabName === 'Managed') {
      this.deviceAvailable = false;
      this.assignData();
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.deviceAvailable = true;
      }, 1);
    }
  }

  // Update the data source cache whenever an item is updated
  onDatasourceUpdated(): void {
    this.deviceService.updateCache();
    this.resetCheckbox.next([]);
  }

  populateDeviceData(): void {
    this.cacheObj = this.deviceService.cache.subscribe(async data => {
      this.benchmarkService.registerPageEvent('dataSourcePageRendering');
      const filteredData = this.deviceService.getUniqueValues();
      this.deviceDataSource = this.dataSourceService.sortDataByName(filteredData);
      await this.getjmepImagesList();
      this.getLatestFirmwareVersion();
      this.getTranformedData$();
    });
    this.queuedService.usedTestCountCache.pipe(takeUntil(this.unsubscribe)).subscribe(monitors => {
      if (monitors?.length) {
        this.deviceWithMonitors = monitors;
        this.getTranformedData$();
      }
    });
  }

  getTranformedData$(): void {
    this.currentDataSource = this.transformResponse(this.deviceDataSource);
    this.assignData();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  assignData(): void {
    this.dataSourceTableData = this.transformService.transformData(
      'datasource-management',
      this.currentDataSource
    );
    if (this.dataSourceTableData?.data) {
      this.currentTableDatasource = !this.esamFiltered
        ? this.dataSourceTableData.data
        : this.dataSourceTableData.data.filter(
            data => data.dataItem.capabilities?.phy?.['esam-guid'] === this.selectedEsamItem.id
          );
    }
    this.table.columns = this.dataSourceTableData.column;
    this.table.data = this.currentTableDatasource;
    this.table = Object.assign({}, this.table);
    this.getCounterItems();
    this.benchmarkService.logPageEventTime('datasourcepage rendering', 'dataSourcePageRendering');
  }

  getCounterItems(): void {
    const data = this.child?.table?.getHeaderFilters().length
      ? this.child.filteredItems()
      : this.currentTableDatasource;
    if (data.length) {
      this.deviceCounters[0].count = data.length;
      this.deviceCounters[1].count = data.filter(
        device =>
          device.dataItem.activity?.status === 'idle' &&
          device.dataItem.activity?.p1?.status !== 'running' &&
          device.dataItem.activity?.p2?.status !== 'running'
      ).length;
      this.deviceCounters[2].count = data.filter(
        device =>
          device.dataItem.activity?.status === 'running' ||
          device.dataItem.activity?.p1?.status === 'running' ||
          device.dataItem.activity?.p2?.status === 'running'
      ).length;
      this.deviceCounters[3].count = data.filter(item => item.status === 'online').length;
      this.deviceCounters[4].count = data.filter(item => item.status === 'offline').length;
      this.deviceCounters[0].count = data.length;
    }
    const selectedItem = this.deviceCounters.find(item => item.id === this.selectedFilterItem);
    this.counterSelected(selectedItem);
  }

  //eslint-disable-next-line
  removeJmepDevice(deviceObj: any): any {
    return deviceObj.filter(data => !data.type.label?.toLowerCase().includes('jmep'));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getDataSourceById(id: any): any {
    return find(this.currentDataSource, function (data) {
      return data.id === id;
    });
  }
  exportDevice(): void {
    this.exportUnmanagedDevice.next(true);
  }
  refreshUnmanagedDevices(): void {
    this.refreshTable.next(true);
  }

  refreshApplicationPage(): void {
    this.refreshApplications.next(true);
  }

  // eslint-disable-next-line
  sendPopupAction(event: any): void {
    this.goToTestListPage(event[0], true);
  }

  clearEsamFilter(): void {
    this.esamFiltered = false;
    this.child.table.clearFilter(true);
    this.child.table.deselectRow();
    this.previousAgentFilter.forEach(element => {
      this.child.table.setHeaderFilterValue(element.field, element.value);
    });
    this.currentTableDatasource = Object.assign([], this.dataSourceTableData.data);
    this.table.columns = this.dataSourceTableData.column;
    this.table.data = this.currentTableDatasource;
    this.table = Object.assign({}, this.table);
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  transformResponse(dataIn: Array<Device>): any[] {
    const tranformedData = [];
    const deviceData = map(dataIn, data => data.deviceData);
    if (!isEmpty(deviceData) && isArray(deviceData)) {
      forEach(deviceData, (item: IDeviceData) => {
        if (
          item.name &&
          item.name.indexOf('_DESTROYED_') < 0 &&
          item.type === DataSource.GIGA_TEST
        ) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const deviceDataItem = item;
          const isupgradeDisabled = item?.model?.model?.includes('JMEP')
            ? !this.checkJmepUpgrade(item)
            : !this.checkUpgrade(item);
          const deviceManagementActions = this.transformService.getDeviceManagmentActions(
            deviceDataItem,
            isupgradeDisabled
          );
          const deviceActions = this.transformService.getActionsByAgentType(
            deviceManagementActions[0].actions,
            deviceDataItem
          );
          const stateActions = [{ label: '', actions: deviceActions }];
          const result: any = {};
          switch (item.type) {
            case DataSource.GIGA_TEST:
              result.id = item.uniqueId;
              result.name = this.getIconLabelName(item.nameId, this.dataSourceNameImg, item);
              result.type = this.transformService.getDeviceTypeInfo(
                this.getParamsValueByName(item.params, this.platform)
              );
              result.dataType = item.type;
              result.status = item.status;
              result.location = item.location ? item.location : '--';
              result.state = item.state;
              result.dataItem = item;
              result.registeredState = this.getLastRegistrationState(item.params);
              result.version = this.getVersionInfo(item);
              result.isDisabled = !this.isCheckboxDisabled(item);
              result.isUpdateButtonEnabled = this.checkUpdate(item);
              result.removeType = DataSource.GIGA_TEST;
              result.hasAgentUrl = !!this.availableFirmwareVersion[result.type.label];
              result.ipAddress = item.phyId ? '' : { label: item.ipaddress };
              result.mgmtIpAddress = this.getManagementIpInfo(item);
              result.testAssigned = item.phyId
                ? ''
                : this.getTestAssignedDatasource(
                    this.getActiveTestQueuedStatus(this.deviceWithMonitors, item.id),
                    item.nameId
                  );
              result.actions = stateActions;
              result.children = this.getTableChildren(item);
              break;
          }
          tranformedData.push(result);
        }
      });
    }
    return tranformedData;
  }

  getManagementIpInfo(deviceData: IDeviceData): any {
    let indicatorIcon = null;
    if (
      deviceData?.model?.model.includes('JMEP') &&
      deviceData?.capabilities?.system?.discoveryMode === 'IP-1'
    ) {
      indicatorIcon = 'wifi_tethering';
    }
    return { label: deviceData.mgmtIPaddress, icon: indicatorIcon, title: 'Broadcast address' };
  }

  getTableChildren(deviceData: IDeviceData): any {
    const children = [];
    if (deviceData.capabilities?.['phy-list']) {
      deviceData.capabilities['phy-list'].forEach(item => {
        const agentId =
          item['phy-id'] === 'p1' ? deviceData.uniqueId + '-port1' : deviceData.uniqueId + '-port2';
        children.push({
          id: deviceData.id,
          name: this.getIconLabelName(item.name, this.dataSourceNameImg, deviceData),
          type: this.transformService.getDeviceTypeInfo(
            this.getParamsValueByName(deviceData.params, this.platform)
          ),
          dataType: deviceData.type,
          location: deviceData.location ? deviceData.location : '--',
          status: deviceData.status,
          state: deviceData.state,
          dataItem: deviceData,
          registered: this.transformService.getISODateTimeFormat(
            this.getLastRegistrationState(deviceData.params)
          ),
          version: this.getChildVersionInfo(deviceData),
          isDisabled: true,
          ipAddress: { label: item['default-test-ip'] || item['external-test-ip'] },
          mgmtIpAddress: { label: deviceData.mgmtIPaddress },
          testAssigned: this.getTestAssignedDatasource(
            this.getActiveTestQueuedStatus(this.deviceWithMonitors, agentId),
            deviceData.nameId
          ),
          isCheckboxDisabled: true
        });
      });
      return children;
    }
    return null;
  }

  //eslint-disable-next-line
  isCheckboxDisabled(item: IDeviceData): boolean {
    const platform = this.getParamsValueByName(item.params, this.platform);
    const agentType = this.transformService.getAgentTypeBasedOnPlatform(platform);
    // when upgrade stated and in upgrading state, user should not select agent again for upgrade or Remove
    if (agentType === AGENT_MODEL.JMEP_10G || agentType === AGENT_MODEL.JMEP_1G) {
      return item.substatus === SUB_STATUS.upgrade ? false : true;
    } else {
      if (
        !this.isUpgradeSupported(item.status, agentType, item) ||
        item.substatus === SUB_STATUS.upgrade
      ) {
        return false;
      }
      return this.getUpgradeAvailable(item);
    }
  }

  //eslint-disable-next-line
  getActiveTestQueuedStatus(deviceWithMonitors: any, id: string): any {
    return deviceWithMonitors.find(device => device.deviceData.id === id);
  }

  // eslint-disable-next-line
  getTestAssignedDatasource(data: any, deviceName: string): any {
    const dataSource = [];
    const testAssignedData = data?.queueStatus;
    for (const key in testAssignedData) {
      if (testAssignedData[key]?.total) {
        dataSource.push({
          type: key,
          used: testAssignedData[key]?.used,
          max: testAssignedData[key]?.total,
          className: this.tabulatorService.getTestTypeImage(key),
          maxCount: testAssignedData['maxCount'],
          overalUsed: testAssignedData['overall_total_used'],
          overalPercentage: Number.isNaN(testAssignedData['overall_percentage'])
            ? -1
            : testAssignedData['overall_percentage'],
          deviceName: deviceName,
          hasOveralPercentage: Number.isInteger(testAssignedData['overall_percentage'])
            ? 'block'
            : 'none',
          showProgressBar: Number.isInteger(testAssignedData['overall_percentage'])
            ? 'none'
            : 'block',
          hideView: false
        });
      }
    }
    return dataSource;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getParamsValueByName(params: any, name: string): any {
    const paramsObj = find(params, ['name', name]);
    return paramsObj && paramsObj.value ? paramsObj.value : '';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getRegistationState(param: any): any {
    for (const item of param) {
      if (item.name === this.registrationTime) {
        return item.value !== '' ? item.value : 'Unregistered';
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getLastRegistrationState(param: any): any {
    for (const item of param) {
      if (item.name === this.lastRegistrationTime) {
        return item.value !== '' ? item.value : 'Unregistered';
      }
    }
  }

  // eslint-disable-next-line
  getAvailableJmepVersion(agent: IDeviceData): Array<any> {
    const jmepVersion = this.getParamsValueByName(agent?.params, this.version);
    const agentType = this.getParamsValueByName(agent?.params, 'model');
    const upgardeImagesList = this.getAvailableUpgradeVersionsForJmep(jmepVersion, agentType);
    return upgardeImagesList.filter(list => list.version !== jmepVersion);
  }

  getAvailableUpgradeVersionsForJmep(jmepVersion: string, agentType: string): any {
    const upgardeAvailableImages = [];
    let currentMajorVersion = null;
    if (jmepVersion && this.availableJmepVersions?.length) {
      currentMajorVersion = jmepVersion.split('.')[0];
      const majorMinorVersion = this.jmepConfigureService.getMajorMinorVersion(jmepVersion);
      const isJmep10gVersionOne = this.jmepConfigureService.isJmep10versionOne(jmepVersion);
      this.availableJmepVersions.forEach(element => {
        const vItems = element.version.split('.');
        const imageMajorMinVersion = vItems[0] + '.' + vItems[1];
        if (currentMajorVersion && agentType === AGENT_MODEL.JMEP_10G) {
          // Version one will allow to upgrade version one images only
          if (
            isJmep10gVersionOne &&
            this.jmepConfigureService.isJmep10versionOne(element.version)
          ) {
            upgardeAvailableImages.push(element);
          } else if (
            !isJmep10gVersionOne &&
            parseFloat(imageMajorMinVersion) >= parseFloat(majorMinorVersion)
          ) {
            // MV-18852 Version two will allow to upgrade greater version images
            upgardeAvailableImages.push(element);
          }
        } else if (
          currentMajorVersion === null ||
          element?.version.split('.')[0].indexOf(currentMajorVersion) >= 0
        ) {
          upgardeAvailableImages.push(element);
        }
      });
    }
    return upgardeAvailableImages;
  }

  isJmepAgent(agentType: string): boolean {
    return agentType?.indexOf('JMEP') !== -1;
  }

  getLatestUpgradeversion(item: IDeviceData): Array<any> {
    let versionsList = [];
    const platform = this.getParamsValueByName(item.params, this.platform);
    const agentType = this.transformService.getAgentTypeBasedOnPlatform(platform);
    const currentVersion = this.getParamsValueByName(item.params, this.version);
    const availableVersions = this.isJmepAgent(agentType)
      ? this.getAvailableJmepVersion(item)
      : this.availableFirmwareVersion[agentType];
    if (availableVersions?.length > 0) {
      versionsList = availableVersions.filter(
        list => list.version !== currentVersion && this.compareVersion(list.version, currentVersion)
      );
      if (versionsList.length) {
        versionsList = versionsList.sort((a, b) => b - a);
        versionsList.length = 1;
      }
    }
    return versionsList;
  }

  getVersionInfo(item: IDeviceData): ITextIconLabel {
    const version = this.getParamsValueByName(item.params, this.version);
    const latestVersion = this.getLatestUpgradeversion(item);
    const upgradeAvailable = latestVersion?.length ? true : false;
    const statusInfo = this.getUpgradeStatusInfo(item, upgradeAvailable);
    const upgradeVersionInfo = upgradeAvailable
      ? 'Available version : ' + latestVersion?.[0]?.version
      : '';

    return {
      emit: upgradeAvailable && item?.substatus !== SUB_STATUS.upgrade,
      id: 'version',
      label: version && version !== 'null' ? version : 'Unknown',
      upgradeStatus: statusInfo.text,
      upgradeClass: statusInfo.className,
      upgradeInfo: upgradeVersionInfo,
      matIcon: statusInfo.icon,
      sublabel: statusInfo.text
    };
  }

  getChildVersionInfo(item: IDeviceData): ITextIconLabel {
    const version = this.getParamsValueByName(item.params, this.version);
    return {
      emit: false,
      id: 'version',
      label: version && version !== 'null' ? version : 'Unknown',
      upgradeStatus: null,
      upgradeClass: null,
      upgradeInfo: null,
      matIcon: null,
      sublabel: null
    };
  }

  getUpgradeStatusInfo(
    item: IDeviceData,
    upgradeAvailable: boolean
  ): { text: string; className: string; icon: string } {
    const updateInfo = {
      text: '',
      className: '',
      icon: ''
    };
    const platform = this.getParamsValueByName(item.params, this.platform);
    const agentType = this.transformService.getAgentTypeBasedOnPlatform(platform);
    if (this.isUpgradeSupported(item.status, agentType, item)) {
      if (item?.substatus === SUB_STATUS.upgrade) {
        updateInfo.text = UPGRADE_DISPLAY_MESSAGE.upgrading;
        updateInfo.className = 'upgrading';
        return updateInfo;
      }
      if (
        item?.lastUpgradeMessage === LAST_UPGRADE_MESSAGE.success &&
        !upgradeAvailable &&
        this.keepUpgradeMessageSpecificTime(item, this.timeInterval.oneDay)
      ) {
        updateInfo.text = UPGRADE_DISPLAY_MESSAGE.success;
        updateInfo.className = 'upgraded';
        updateInfo.icon = 'done';
        return updateInfo;
      }
      if (
        item?.substatus !== SUB_STATUS.upgrade &&
        upgradeAvailable &&
        (item?.lastUpgradeMessage !== LAST_UPGRADE_MESSAGE.failed ||
          (item?.lastUpgradeMessage === LAST_UPGRADE_MESSAGE.failed &&
            !this.keepUpgradeMessageSpecificTime(item, this.timeInterval.oneDay)))
      ) {
        updateInfo.text = UPGRADE_DISPLAY_MESSAGE.available;
        updateInfo.className = 'available';
        return updateInfo;
      }
    }
    if (
      item?.lastUpgradeMessage === LAST_UPGRADE_MESSAGE.failed &&
      this.keepUpgradeMessageSpecificTime(item, this.timeInterval.oneDay) &&
      upgradeAvailable
    ) {
      updateInfo.text = UPGRADE_DISPLAY_MESSAGE.failed;
      updateInfo.className = 'failed';
      updateInfo.icon = 'error_outline';
      return updateInfo;
    }
    return updateInfo;
  }

  checkJmepUpgrade(item: IDeviceData): boolean {
    const platform = this.getParamsValueByName(item.params, this.platform);
    const agentType = this.transformService.getAgentTypeBasedOnPlatform(platform);
    // when upgrade stated and in upgrading state, user should not select agent again for upgrade
    if (
      !this.isUpgradeSupported(item.status, agentType, item) ||
      item.substatus === SUB_STATUS.upgrade
    ) {
      return false;
    }
    return this.getAvailableJmepVersion(item)?.length > 0;
  }

  keepUpgradeMessageSpecificTime(item: IDeviceData, timeInterval: number): boolean {
    const currentTimeStamp = new Date().getTime();
    if (item.lastUpgradeMessageTime) {
      const lastUpgradeTimestamp = new Date(item.lastUpgradeMessageTime).getTime();
      return currentTimeStamp - lastUpgradeTimestamp < timeInterval;
    }
    return false;
  }

  checkUpgrade(item: IDeviceData): boolean {
    const platform = this.getParamsValueByName(item.params, this.platform);
    const agentType = this.transformService.getAgentTypeBasedOnPlatform(platform);
    // when upgrade stated and in upgrading state, user should not select agent again for upgrade
    if (
      !this.isUpgradeSupported(item.status, agentType, item) ||
      item.substatus === SUB_STATUS.upgrade
    ) {
      return false;
    }
    return this.getUpgradeAvailable(item);
  }

  checkUpdate(item: IDeviceData): boolean {
    const platform = this.getParamsValueByName(item.params, this.platform);
    const agentType = this.transformService.getAgentTypeBasedOnPlatform(platform);
    if (!this.isUpdateSupported(item, agentType)) {
      return false;
    }
    return this.getUpgradeAvailable(item);
  }

  // eslint-disable-next-line
  openAgentDetailsDialog(data: any): void {
    if (data.dataItem.model?.model.includes('JMEP')) {
      data.dataItem.capabilities.phy = {
        ...data.dataItem.capabilities.phy,
        'test-vlan-id':
          Number(data.dataItem.capabilities.phy['test-vlan-id']) > 0
            ? data.dataItem.capabilities.phy['test-vlan-id']
            : 0,
        'esam-name': data.name.sublabel?.split('ESAM:')[1],
        'esam-ip': data.dataItem.capabilities.phy['management-ip']
      };
      delete data.dataItem.capabilities.phy['management-ip'];
    }
    const dialogData = {
      deviceName: data.dataItem.nameId,
      data: data.dataItem,
      model: data.dataItem?.model?.model
    };
    this.dialog.open(AgentSpecComponent, {
      width: '66rem',
      disableClose: true,
      data: dialogData
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  openAlarmsDialog(data: any): void {
    // data.dataItem['model']['model'] = data.dataItem.model.model ?? '';
    // data.dataItem['model']['version'] = data.dataItem.model.version ?? '';
    // const dialogData = { deviceName: data.dataItem.name, data: data.dataItem.capabilities };
    this.dialog.open(AlarmsDialogComponent, {
      // width: '66rem',
      disableClose: true,
      data: data
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  openTrafficResultsDialog(data: any): void {
    // eslint-disable-next-line no-console
    const evcObject = {
      configId: data.name.label, //sublabel.split(': ')[1],
      endpointName: data.name.label
    };
    // const dialogData = { evcObject };
    this.dialog.open(TrafficResultsComponent, {
      maxWidth: '99.5vw',
      height: '90%',
      disableClose: true,
      data: evcObject
    });
  }

  jmepsBulkTransfer(): void {
    const selectedJMEPs = this.child?.selection?.map(x => x) || [];
    if (selectedJMEPs.length) {
      this.openTransferDeviceDialog(selectedJMEPs);
    }
  }

  // eslint-disable-next-line
  transferDevicesAction(data: any): void {
    const selectedJMEPs = [];
    selectedJMEPs.push(data);
    this.openTransferDeviceDialog(selectedJMEPs);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  openTransferDeviceDialog(data: any): void {
    const dataTransferValue = { data: data, deviceList: this.deviceList };
    this.jmepTransferDialogRef = this.dialog.open(TransferDeviceComponent, {
      disableClose: true,
      data: dataTransferValue
    });
    this.jmepTransferDialogRef.afterClosed().subscribe(res => {
      if (res?.[0]?.transferStatus && data) {
        for (let i = 0; i < data.length; i++) {
          this.currentDataSource = filter(
            this.currentDataSource,
            (ds: any) => ds.id !== data[i].id
          );
          this.deviceService.removeDevicesFromCache(data[i].id);
        }
      }
    });
  }

  getUpgradeAvailable(item: IDeviceData): boolean {
    const currentVersion = this.getParamsValueByName(item.params, this.version);
    const platform = this.getParamsValueByName(item.params, this.platform);
    const agentType = this.transformService.getAgentTypeBasedOnPlatform(platform);
    if (this.availableFirmwareVersion[agentType]) {
      const availableVersions = this.availableFirmwareVersion[agentType];
      const versionsList = availableVersions
        .map(list => {
          if (list.version !== currentVersion) {
            return list.version;
          }
        })
        .filter(notUndefined => notUndefined !== undefined);

      return versionsList.length > 0;
    } else {
      return false;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  isUpgradeSupported(status: string, agentType: AGENT_MODEL, item: any): boolean {
    const version = this.getParamsValueByName(item.params, this.version);
    return (
      status === 'online' &&
      ((agentType === AGENT_MODEL.HARDWARE &&
        this.compareVersion(version, UPGRADE_AVAILABLE_HARDWARE_VERSION)) ||
        (agentType === AGENT_MODEL.VQT &&
          this.compareVersion(version, UPGRADE_AVAILABLE_VQT_VERSION)) ||
        agentType === AGENT_MODEL.QT600 ||
        (agentType === AGENT_MODEL.MAP2100 &&
          this.compareVersion(version, UPGRADE_AVAILABLE_MAP2100_VERSION)) ||
        agentType === AGENT_MODEL.VSPA ||
        agentType === AGENT_MODEL.JMEP_10G ||
        agentType === AGENT_MODEL.JMEP_1G ||
        agentType?.toLowerCase().includes('vspa'))
    );
  }

  compareVersion(availableVersion: string, currentVersion: string): boolean {
    if (availableVersion && currentVersion) {
      currentVersion = currentVersion.replace(/-/g, '.');
      availableVersion = availableVersion.replace(/-/g, '.');
      return this.utilService.compareVersion(availableVersion, currentVersion);
    }
    return false;
  }
  isUpdateSupported(item: IDeviceData, agentType: AGENT_MODEL): boolean {
    const version = this.getParamsValueByName(item.params, this.version);
    return (
      (item.status === 'online' || item.status === 'offline') &&
      [AGENT_MODEL.WINDOWS].includes(agentType) &&
      version !== 'unknown'
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getDataInfoByKey(dataInfo: any, key: string): any {
    return get(dataInfo, key, '');
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  getIconLabelName(
    labelName: string,
    iconName: string,
    deviceData: IDeviceData
  ): { icon: string; label: string; sublabel: string } {
    return {
      icon: '',
      label: labelName,
      sublabel: this.transformService.getEsamName(deviceData, this.deviceDataSource)
    };
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSiteLocationById(siteId: string): { label: string; sublabel: ''; location: any } {
    const siteObj: Site = this.getSitesById(siteId);
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sitesInfo: any = {
      label: '',
      sublabel: '',
      location: {}
    };
    if (siteObj) {
      sitesInfo.label = siteObj.getName();
      sitesInfo.sublabel = siteObj.getLocationName();
      sitesInfo.location = siteObj.getLocation();
    }
    return sitesInfo;
  }

  getSitesById(siteId: string): Site {
    return this.sitesData.find(site => site.getId().toString() === siteId);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getSiteLocationName(location: any): { label: string; sublabel: string } {
    const sitesInfo = {
      label: '',
      sublabel: ''
    };
    if (location) {
      sitesInfo.label = location.region;
      sitesInfo.sublabel = location.name;
    }
    return sitesInfo;
  }

  hasData(): boolean {
    return isArray(this.currentDataSource) && !isEmpty(this.currentDataSource);
  }
  // eslint-disable-next-line

  // eslint-disable-next-line
  removeDataSourceItem(removeItem: any): void {
    this.isLoading = true;
    this.dataSourceService
      .removeManagedDevices(removeItem, this.enableForceOption)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          for (let i = 0; i < removeItem.length; i++) {
            this.currentDataSource = filter(
              this.currentDataSource,
              (ds: any) => ds.id !== removeItem[i].id
            );
            this.deviceService.removeDevicesFromCache(removeItem[i].id);
          }
          this.isLoading = false;
          this.enableForceOption = false;
          const successMsg = 'Datasource removed successfully';
          this.notificationService.onSuccess(successMsg);
        },
        () => {
          const errorMsg = 'There is problem while removing datasource';
          this.notificationService.onFail(errorMsg);
          this.isLoading = false;
        },
        () => {}
      );
  }

  // eslint-disable-next-line
  resyncDataSourceItem(item: any): void {
    this.isLoading = true;
    const esamUrl =
      item && item.dataItem[0]
        ? item.dataItem[0].connections[0].uri
        : item.dataItem.connections[0].uri;
    this.dataSourceService
      .resyncDataSource$(esamUrl, [item.dataItem.capabilities.phy['jmep-id']])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.isLoading = false;
          if (response?.status === 'success') {
            const successMsg = `JMEP has been resynced. The list will refresh momentarily.`;
            this.notificationService.onSuccess(successMsg);
          } else {
            const errorMsg = `JMEP resync failed: ${response.data.message}`;
            this.notificationService.onFail(errorMsg);
          }
        },
        () => {
          this.notificationService.onFail('Failed to resync JMEP.');
          this.isLoading = false;
        },
        () => {}
      );
  }

  // eslint-disable-next-line
  stopDataSourceItem(item: any): void {
    this.isLoading = true;
    const esamUrl =
      item && item.dataItem[0]
        ? item.dataItem[0].connections[0].uri
        : item.dataItem.connections[0].uri;
    this.dataSourceService
      .stopLoopbackDataSource$(esamUrl, [item.dataItem.capabilities.phy['jmep-id']])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.isLoading = false;
          if (response?.status === 'success') {
            this.notificationService.onSuccess(
              'JMEP loopbacks are stopping and should be complete in 5 minutes.'
            );
          } else {
            const errorMsg = `Stop JMEP loopbacks failed: ${response.data.message}`;
            this.notificationService.onFail(errorMsg);
          }
        },
        () => {
          this.notificationService.onFail('Stop JMEP loopbacks failed. Please try again.');
          this.isLoading = false;
        },
        () => {}
      );
  }

  // eslint-disable-next-line
  restartDataSourceItem(item: any): void {
    this.isLoading = true;
    const esamUrl =
      item && item.dataItem[0]
        ? item.dataItem[0].connections[0].uri
        : item.dataItem.connections[0].uri;
    this.dataSourceService
      .restartDataSource$(esamUrl, [item.dataItem.capabilities.phy['jmep-id']])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.isLoading = false;
          if (response?.status === 'success') {
            const successMsg = `JMEP is restarting and should be online in 5 minutes.`;
            this.notificationService.onSuccess(successMsg);
          } else {
            const errorMsg = `JMEP restart failed: ${response.data.message}`;
            this.notificationService.onFail(errorMsg);
          }
        },
        () => {
          this.notificationService.onFail('Failed to restart JMEP.');
          this.isLoading = false;
        },
        () => {}
      );
  }
  // eslint-disable-next-line
  rebootDataSourceItem(item: any): void {
    this.isLoading = true;
    this.dataSourceService
      .rebootDatasource$(item)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.isLoading = false;
          if (response?.status === '0') {
            const successMsg = `Agent ${item.dataItem.deviceName} is rebooting. Please allow 5 minutes for the agent to come back online`;
            this.notificationService.onSuccess(successMsg);
          } else {
            const errorMsg = `Failed to reboot agent ${item.dataItem.deviceName}.${response.message}`;
            this.notificationService.onFail(errorMsg);
          }
        },
        () => {
          const errorMsg = `Failed to reboot agent ${item.dataItem.deviceName}. `;
          this.notificationService.onFail(errorMsg);
          this.isLoading = false;
        },
        () => {}
      );
  }

  // eslint-disable-next-line
  editDataSourceItem(item: any): void {
    this.editDeviceDialogRef = this.dialog.open(EditManagedDeviceComponent, {
      width: '70rem',
      disableClose: true,
      data: { device: item, editMode: true }
    });
  }
  // eslint-disable-next-line
  editJmepV1Configure(item: any): void {
    this.jmepConfigureDialogRef = this.dialog.open(JmepConfigureManagementComponent, {
      width: '70rem',
      disableClose: true,
      data: { device: item, editMode: true }
    });
  }
  // eslint-disable-next-line
  editJmepV2Configure(item: any): void {
    this.jmepV2ConfigureDialogRef = this.dialog.open(JmepV2ConfigureManagementComponent, {
      width: '80rem',
      disableClose: true,
      data: { device: item, editMode: true }
    });
  }

  // eslint-disable-next-line
  upgradeJmepDevices(item: any, isInplaceAgentUpgrade: boolean): void {
    const selectedAgents = [];
    const jmepSvrUrl = item?.dataItem?.connections[0]?.uri || '';
    const agentType = this.getParamsValueByName(item?.dataItem?.params, 'model');
    this.selectedAgentAvailableVersion = isInplaceAgentUpgrade
      ? this.getLatestUpgradeversion(item.dataItem)
      : this.getAvailableJmepVersion(item.dataItem);
    selectedAgents.push(item?.dataItem.id);
    this.openUpgradeWizard(selectedAgents, jmepSvrUrl, agentType);
  }

  //* Individual Agent upgrade action from agents with generic updates */
  // eslint-disable-next-line
  upgradeDataSourceItem(item: any, isInplaceAgentUpgrade?: boolean): void {
    const selectedAgents = [];
    let availableVersions = [];
    const version = item?.version?.label || null;
    selectedAgents.push(item.id);
    const agentType = this.getParamsValueByName(item?.dataItem?.params, 'model');
    this.selectedAgentAvailableVersion = !isInplaceAgentUpgrade
      ? this.availableFirmwareVersion[item.type.name]
      : this.getLatestUpgradeversion(item.dataItem);
    if (this.availableFirmwareVersion[item.type.name] && version) {
      availableVersions = this.availableFirmwareVersion[item.type.name];
      this.selectedAgentAvailableVersion = availableVersions.filter(
        list => list.version !== version
      );
    }
    this.openUpgradeWizard(selectedAgents, null, agentType);
  }

  openUpgradeWizard(selectedAgents: string[], url: string, agentType: string): void {
    setTimeout(() => {
      this.dataSourceService.navigateToWizard('upgrade_agent', {
        version: this.selectedAgentAvailableVersion,
        agents: selectedAgents,
        url: url,
        model: agentType
      });
    }, 100);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getNavigateURL(dataType: any, agentType: any): string {
    let navigateUrl;
    switch (dataType) {
      case DataSource.GIGA_TEST: {
        navigateUrl = 'update_gigatest_datasource';
        break;
      }
      default: {
        navigateUrl = 'update_datasource';
        break;
      }
    }
    return navigateUrl;
  }

  addDataSource(): void {
    this.dataSourceService.navigateToWizard('add_datasource');
  }

  //* Bulk upgrade action */
  upgradeAgent(): void {
    const agentType = this.child?.selection[0].type.label;
    const selectedAgents = this.getSelectedItemsIds();
    this.selectedAgentAvailableVersion = this.availableFirmwareVersion[agentType];
    const url = this.minoURL[agentType];
    this.openUpgradeWizard(selectedAgents, url, agentType);
  }

  deviceCacheUpdate(): void {
    this.onDatasourceUpdated();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  showGigaTestDetails(GigaTestData: any): void {
    this.dataSourceService.navigateToWizard('datasource_gigatest_info', GigaTestData);
  }

  updateReadWriteRoleInfo(): void {
    this.hasReadWriteRole = this.userAuth.isAuthedFor('READ_WRITE');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  disableItem(item: any): void {
    this.updateDataSourceState(item, DataSourceState.DISABLED);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  enableItem(item: any): void {
    this.updateDataSourceState(item, DataSourceState.ENABLED);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  updateDataSourceState(item: any, status: DataSourceState): void {
    this.isLoading = true;
    const dataId = item.id;
    this.dataSourceService
      .updateDataSourceState(dataId, status, item.dataType, item)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => {
          const updatedStatus = status === 'enabled' ? 'online' : 'disabled';
          item.status = updatedStatus;
          const data = this.deviceService.getDevices().find(d => d.getId() === item.id);
          this.deviceService.updateDeviceStatus(data.getId(), updatedStatus);
          this.isLoading = false;
          const successMsg = 'Datasource status updated successfully';
          this.notificationService.onSuccess(successMsg);
        },
        () => {
          const errorMsg = 'There is problem while updating status';
          this.isLoading = false;
          this.notificationService.onFail(errorMsg);
        }
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  downloadActiveAgent(agent: { item: any; isUpdateSuccess: boolean }): void {
    if (
      agent.item &&
      (agent.item.platform === 'WINDOWS' || agent.item.platform === 'MAC') &&
      agent.item.agentType === 'TROUBLE_SHOOTING'
    ) {
      this.window.nativeWindow.open(agent.item.download[0], '_blank');
    } else if (
      agent.item &&
      agent.item.platform === 'OLHW' &&
      agent.item.agentType === 'HARDWARE_AGENT'
    ) {
      return;
    } else {
      this.agentDownloadService.openDialog(agent);
    }
  }

  // eslint-disable-next-line
  onActionClick(action: any): any {
    let isInplaceAgentUpgrade = false;
    if (
      action.label === 'singleSelect' &&
      action?.cellValue?.id == 'version' &&
      action?.cellValue?.emit
    ) {
      isInplaceAgentUpgrade = true;
      action.label =
        action.rowData?.type?.name.indexOf('JMEP') !== -1
          ? FUSION_AGENT_ACTION_NAME.UPGRADE_JMEPS
          : FUSION_AGENT_ACTION_NAME.UPGRADE_AGENT;
    }
    switch (action.label) {
      case FUSION_AGENT_ACTION_NAME.VIEW_TESTS:
        this.goToTestListPage(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.DISABLE:
        this.disableDatasource(action.rowData, true);
        break;
      case FUSION_AGENT_ACTION_NAME.ENABLED:
        this.enableDatasource(action.rowData, true);
        break;
      case FUSION_AGENT_ACTION_NAME.EDIT:
        this.editDataSourceItem(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.REMOVE:
        this.removeConfirmation(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.DOWNLOAD_AGENT:
        this.getDownloadAgentDetails(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.REBOOT:
        this.rebootAgentConfirmation(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.RESTART:
        this.restartAgentConfirmation(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.RESYNC:
        this.resyncAgentConfirmation(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.STOP:
        this.stopLoopbackConfirmation(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.UPGRADE_AGENT:
        this.upgradeDataSourceItem(action.rowData, isInplaceAgentUpgrade);
        break;
      case FUSION_AGENT_ACTION_NAME.UPGRADE_JMEPS:
        this.upgradeJmepDevices(action.rowData, isInplaceAgentUpgrade);
        break;
      case FUSION_AGENT_ACTION_NAME.UPDATE_AGENT:
        this.UpdateWindowsAgentVersion(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.AGENT_SPECS:
        this.openAgentDetailsDialog(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.ALARMS:
        this.openAlarmsDialog(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.TRAFFIC_RESULTS:
        this.openTrafficResultsDialog(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.TRANSFER_DEVICE:
        this.transferDevicesAction(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.VIEW_JMEPS:
        this.showConfiguredJmeps(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.DISCOVER_JMEPS:
        this.openDiscoverJMEPsDialog(action.rowData);
        break;
      case FUSION_AGENT_ACTION_NAME.CONFIGURE:
        if (
          this.jmepConfigureService.loadJmepV1EditConfig(
            action.rowData.dataItem.model.model,
            action.rowData.dataItem.model.version
          )
        ) {
          this.editJmepV1Configure(action.rowData);
        } else {
          this.editJmepV2Configure(action.rowData);
        }

        break;
      case FUSION_AGENT_ACTION_NAME.LOGS:
        this.openLogsInfoDialog(action.rowData);
        break;
    }
  }

  // eslint-disable-next-line
  openLogsInfoDialog(rowData: any): void {
    const agentId = [rowData?.id];
    this.deviceService
      .generateAgentLogs$(agentId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response) {
            this.dialogService.showInfo(
              'information',
              'body',
              'Requests for logs were successfully submitted.</br> You can download it from System settings -> Downloads within a few minutes.',
              `Logs for ${rowData?.name?.label}`
            );
          }
        },
        err => {
          this.notificationService.onFail('Logs generation request failed. Please try again.');
        }
      );
  }
  // eslint-disable-next-line
  showConfiguredJmeps(item) {
    this.esamFiltered = true;
    this.selectedEsamItem = item;
    this.selectedEsamName = item.name.label;
    this.currentTableDatasource = this.dataSourceTableData.data.filter(
      data => data.dataItem.capabilities?.phy?.['esam-guid'] === item.id
    );
    this.previousAgentFilter = this.child.table.getHeaderFilters();
    this.child.table.clearFilter(true);
    this.child.table.deselectRow();
    this.table.columns = this.dataSourceTableData.column;
    this.table.data = Object.assign([], this.currentTableDatasource);
    this.table = Object.assign({}, this.table);
  }

  // eslint-disable-next-line
  openDiscoverJMEPsDialog(item: any): void {
    const discoverData = {
      selectedEsam: item,
      serverConfig: this.serverConfig
    };
    this.jmepDiscoverDialogRef = this.dialog.open(JmepDiscoverDialogComponent, {
      width: '110rem',
      height: '60rem',
      disableClose: true,
      data: discoverData
    });
  }

  // eslint-disable-next-line
  removeConfirmation(item: any): void {
    this.enableForceOption = false;
    if (item?.type?.name === 'ESAM') {
      const jmepDevices = this.dataSourceTableData.data.filter(
        data => data.dataItem.capabilities?.phy?.['esam-guid'] === item.id
      );
      if (jmepDevices.length > 0) {
        this.dialogService.showInfo(
          'information',
          'body',
          'This ESAM is actively managing JMEPs. Please remove all JMEPs and try again.',
          'Cannot Remove ESAM.'
        );
        return;
      }
    }
    if (item?.type?.name?.includes('JMEP')) {
      const getESAM = this.dataSourceTableData.data.filter(
        data => item.dataItem.capabilities?.phy?.['esam-guid'] === data.id
      );
      if (getESAM.length > 0 && getESAM[0].status === 'offline') {
        this.enableForceOption = true;
        this.showRemoveDialogOfflineJmepsandESAM(item, getESAM[0]?.name?.label);
        return;
      }
    }

    this.showRemoveDialog(item);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  showRemoveDialog(item: any): void {
    const params = {
      id: 'datasource.delete',
      alternateTitle: `Remove ${item.name.label} ?`,
      callBackFnParams: item,
      callBackService: this,
      callBackFuntion: this.callBackRemoveFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  showRemoveDialogOfflineJmepsandESAM(item: any, esamName: string): void {
    const params = {
      id: 'datasource.forceDelete',
      alternateTitle: `Remove ${item.name.label} ?`,
      callBackFnParams: item,
      alternateMsg: `<p class="warning-text"><span class="esam-warning">WARNING</span> ${esamName} <span class="esam-warning">offline</span></p>
        The ESAM cannot be instructed to release JMEPs it currently has activated/online. If the ESAM has connectivity to the JMEPs the JMEPs will fail to be removed.  If you know the ESAM does not have connectivity to the JMEPs you can continue.
        <p class="warning-text">Do you want to continue?</p>`,
      callBackService: this,
      callBackFuntion: this.callBackRemoveFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  // eslint-disable-next-line
  removeBulkJmeps(): void {
    this.enableForceOption = false;
    const selectedJmeps = this.getSelectedItemsIds();
    const jmepsCount = selectedJmeps.length;
    if (jmepsCount > this.maxBulkRemoveLimit) {
      this.dialogService.showInfo(
        'information',
        'body',
        'Only 2000 JMEPs can be removed at a time, Please reduce the number of JMEPs selected.',
        'Error - Exceeds Max Remove limit'
      );
    } else {
      let esamIndex;
      const countString = jmepsCount > 1 ? 'JMEP(s)' : 'JMEP';
      this.child?.selection.forEach(item => {
        esamIndex = this.dataSourceTableData.data.findIndex(
          data =>
            item.dataItem.capabilities?.phy?.['esam-guid'] === data.id && data.status === 'offline'
        );
        if (esamIndex >= 0) {
          return;
        }
      });
      if (esamIndex !== -1) {
        this.enableForceOption = true;
        const params = {
          id: 'datasource.forceDelete',
          alternateTitle: `Remove Selected JMEPs`,
          callBackFnParams: selectedJmeps,
          alternateMsg: `<p class="warning-text"><span class="esam-warning">WARNING</span> ${this.dataSourceTableData.data[esamIndex].name?.label} <span class="esam-warning">offline</span></p>
        <span>${jmepsCount}</span> <span>${countString}</span> selected for removal, The ESAM cannot be instructed to release JMEPs it currently has activated/online. If the ESAM has connectivity to the JMEPs the JMEPs will fail to be removed.  If you know the ESAM does not have connectivity to the JMEPs you can continue.
        <p class="warning-text">Do you want to continue?</p>`,
          callBackService: this,
          callBackFuntion: this.bulkJmpsRemoveAction
        };
        this.dialogService.showDialog('confirm', 'body', params);
      } else {
        const confirmMsg =
          jmepsCount +
          ' ' +
          countString +
          ' selected for removal </br></br> This action will permanently remove this device(s). Would you like to proceed?';
        const params = {
          id: 'datasource.delete',
          alternateTitle: `Remove Selected JMEPs`,
          alternateMsg: `${confirmMsg}`,
          callBackFnParams: selectedJmeps,
          callBackService: this,
          callBackFuntion: this.bulkJmpsRemoveAction
        };
        this.dialogService.showDialog('confirm', 'body', params);
      }
    }
  }

  // eslint-disable-next-line
  bulkJmpsRemoveAction(service: any, items: any): void {
    const selectedItems = items.map(item => find(service.deviceList, device => device.id === item));
    service.removeDataSourceItem(selectedItems);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  actionConfirmation(dialogServiceId: any, item: any, callBack: any) {
    const params = {
      id: dialogServiceId,
      callBackService: this,
      callBackFnParams: item,
      callBackFuntion: callBack
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }
  // eslint-disable-next-line
  callBackRemoveFunction(service: any, item: any): void {
    const removeItem = find(service.deviceList, device => device.id === item.id);
    service.removeDataSourceItem([removeItem]);
  }
  // eslint-disable-next-line
  callBackRebootFunction(service: any, params: any): void {
    service.rebootDataSourceItem(params);
  }

  // eslint-disable-next-line
  callBackRestartFunction(service: any, params: any): void {
    service.restartDataSourceItem(params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  callBackResyncFunction(service: any, params: any): void {
    service.resyncDataSourceItem(params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  callBackStopFunction(service: any, params: any): void {
    service.stopDataSourceItem(params);
  }
  // eslint-disable-next-line
  enableDatasource(item: any, onConfirmation: boolean = false): void {
    const labelText =
      item.dataType === 'GigaStorInstance' ? 'enable.gigastorInstance' : 'enable.dataSource';
    if (onConfirmation) {
      const callBack = function (ref, item) {
        ref.enableItem(item);
      };
      this.actionConfirmation(labelText, item, callBack);
    }
  }
  // eslint-disable-next-line
  disableDatasource(item: any, onConfirmation: boolean = false): void {
    const labelText =
      item.dataType === 'GigaStorInstance' ? 'disable.gigastorInstance' : 'disable.dataSource';
    if (onConfirmation) {
      const callBack = function (ref, item) {
        ref.disableItem(item);
      };
      this.actionConfirmation(labelText, item, callBack);
    }
  }

  // eslint-disable-next-line
  rebootAgentConfirmation(item: any): void {
    const params = {
      id: 'datasource.reboot',
      alternateTitle: `Reboot ${item.dataItem.deviceName} ?`,
      callBackFnParams: item,
      callBackService: this,
      callBackFuntion: this.callBackRebootFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  restartAgentConfirmation(item: any): void {
    const params = {
      id: 'datasource.restart',
      alternateTitle: `Restart ${item.dataItem.deviceName} ?`,
      callBackFnParams: item,
      callBackService: this,
      callBackFuntion: this.callBackRestartFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  resyncAgentConfirmation(item: any): void {
    const params = {
      id: 'datasource.resync',
      alternateTitle: `Resync ${item.dataItem.deviceName} ?`,
      callBackFnParams: item,
      callBackService: this,
      callBackFuntion: this.callBackResyncFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  stopLoopbackConfirmation(item: any): void {
    const params = {
      id: 'datasource.stopLoopback',
      alternateTitle: `Stop loopback and RFC-6349 responder sessions on ${item.dataItem.deviceName} ?`,
      callBackFnParams: item,
      callBackService: this,
      callBackFuntion: this.callBackStopFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  // eslint-disable-next-line
  UpdateWindowsAgentVersion(data: any): void {
    this.isLoading = true;
    this.openDialog(data);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  downloadAgent(item: any, isClickedFromUpdate = false): void {
    if (!item.hasAgentUrl) {
      return;
    }
    this.downloadActiveAgent({ item: item.dataItem, isUpdateSuccess: isClickedFromUpdate });
  }
  // eslint-disable-next-line
  openDialog(item: any): void {
    this.dialogRef = this.dialog.open(CommonDialogComponent, {
      width: '70rem',
      height: '55rem',
      data: {
        isLoading: this.isLoading,
        loaderMessage: 'windows agent exe updating...',
        message: `<html>
          <body>
          <h4>An update is available for your windows agent</h4>
          <span class='subcontent1'>Once the update has completed, you can download the installer to your PC and update the windows agent.</span>
          <div class='subcontent2'>Would you like to proceed in updating your windows agent?</div>
          </body>
          </html>`,
        icon: 'circleMatIcon mdi mdi-download-circle-outline',
        title: 'Windows Agent update',
        okText: 'UPDATE',
        cancelText: 'CANCEL',
        dataItem: item
      }
    });

    this.dialogRef.componentInstance.OnButtonClick.subscribe(data => {
      this.isLoading = true;
      this.updateTestStatusDialog('');
      this.dataSourceService
        .updateWindowsAgentVersioninMinio(data.dataItem.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          response => {
            this.isLoading = false;
            this.dialogRef.close();
            this.deviceCacheUpdate();
            this.downloadAgent(data.dataItem, true);
          },
          //eslint-disable-next-line
          error => {
            this.isLoading = false;
            this.updateTestStatusDialog('There is problem while updating an agent.', true);
          },
          () => {}
        );
    });
  }

  updateTestStatusDialog(message: string, isRequestFailed = false): void {
    const data = {
      isLoading: this.isLoading,
      loaderMessage: 'windows agent exe updating...',
      message: message,
      isRequestFailed: isRequestFailed,
      icon: 'circleMatIcon failure mdi mdi-close-circle-outline',
      title: 'Windows Agent update',
      okText: 'RETRY',
      cancelText: 'CANCEL'
    };

    if (this.dialogRef?.componentInstance) {
      this.dialogRef.componentInstance.updateData(data);
    }
  }
  // eslint-disable-next-line
  goToTestListPage(testInfo?: any, isRunning = false): void {
    testInfo.type =
      testInfo.type === 'twamp'
        ? TestTypeValue.TWAMP
        : testInfo.type === 'LightReflector'
        ? TestTypeValue.TWAMP_LIGHT_REFLECTOR
        : testInfo.type === 'FullReflector'
        ? TestTypeValue.TWAMP_REFLECTOR
        : testInfo.type === 'service'
        ? TestTypeValue.SERVICE_CONTINUITY
        : testInfo.type;
    const expression = isRunning
      ? `device=${testInfo.deviceName}&testtype=${testInfo.type}&status=Running`
      : `device=${testInfo.name.label}`;

    this.navigator
      .addRootParam('test_list_filter', expression)
      .navigateToDashboard('test-list-management', {
        queryParams: { layeredSource: ['Device'], isFilterApplied: 'false' }
      });
  }

  addAgent(): void {
    this.navigator
      .addRootParam('fuzzy_filter', { expression: [] })
      .navigateToWizard(['add_datasource']);
  }
  openProxyPopup(val: boolean): void {
    this.agentControlProxySelectionWindow = val;
  }
  proxyUrlToTooltip(val: boolean): void {
    if (val) {
      this.getProxyInfo();
    }
  }

  downloadAgentWindow(val: boolean): void {
    this.agentDownloadOptionVisibility = val;
  }

  // eslint-disable-next-line
  getDownloadAgentDetails(rowData: any): void {
    this.agentDownloadService
      .loadAgentDetails(rowData.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => {
          this.downloadAgent(rowData);
        },
        err => {
          if (err?.error?.errors[0] === 'Agent not found' || err.status === 404) {
            this.downloadAgentWindow(true);
          }
        },
        () => {}
      );
  }

  //eslint-disable-next-line
  counterSelected(item: any): any {
    this.selectedFilterItem = item.id;
    let fiteredData = [];
    if (this.currentTableDatasource?.length) {
      if (this.selectedFilterItem === 'idle') {
        fiteredData = this.currentTableDatasource.filter(
          device =>
            device.dataItem.activity?.status === 'idle' &&
            device.dataItem.activity?.p1?.status !== 'running' &&
            device.dataItem.activity?.p2?.status !== 'running'
        );
      } else if (this.selectedFilterItem === 'running') {
        fiteredData = this.currentTableDatasource.filter(
          device =>
            device.dataItem.activity?.status === 'running' ||
            device.dataItem.activity?.p1?.status === 'running' ||
            device.dataItem.activity?.p2?.status === 'running'
        );
      } else if (this.selectedFilterItem === 'online') {
        fiteredData = this.currentTableDatasource.filter(item => item.status === 'online');
      } else if (this.selectedFilterItem === 'offline') {
        fiteredData = this.currentTableDatasource.filter(item => item.status === 'offline');
      } else {
        fiteredData = this.currentTableDatasource;
      }
    }
    this.table.data = fiteredData;
    this.table = Object.assign({}, this.table);
  }

  openImportModal(): void {
    this.loadNewData = false;
    this.importDialogRef = this.dialog.open(ImportDevicesComponent, {
      width: '50rem',
      disableClose: true
    });
    this.importDialogRef.afterClosed().subscribe(() => {
      this.loadNewData = true;
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  private getselectedRowId(dataSource: any): string {
    return dataSource.length
      ? (dataSource.find(ds => ds.id === get(this.dataSourceDetails, 'id', ds.id)) || dataSource[0])
          .id
      : 0;
  }
  private getSelectedItemsIds(): string[] {
    return this.child?.selection?.map(x => x.id) || [];
  }

  get isActionsDisabled(): boolean {
    const selectedData = this.child?.selection;
    const hasHardwareAgent = selectedData?.some(item => item.type.label === AGENT_MODEL.HARDWARE);
    const hasVqtAgent = selectedData?.some(item => item.type.label === AGENT_MODEL.VQT);
    if (hasHardwareAgent && hasVqtAgent) {
      return true;
    }
    if (this.getSelectedItemsIds().length === 0) return true;
    else selectedData?.length ? false : true;
  }
  get isActionsShowable(): boolean {
    return this.getSelectedItemsIds().length === 0;
  }

  get isUpgardeDisable(): boolean {
    let dataSource = [];
    let uniqueAgentType = [];
    const filtredData = this.child?.selection?.map(x => x) || [];
    if (filtredData.length) {
      dataSource = filtredData.find(item => item.isDisabled === true);
      const agentTypes = filtredData.map(agent => {
        return agent?.type?.name?.includes('vSPA') ? 'vSPA' : agent?.type?.name;
      });
      //* Bulk upgrade should be same Agent type */
      uniqueAgentType = [...new Set(agentTypes)];
    }
    return dataSource || uniqueAgentType.length > 1 ? true : false;
  }

  /** Bulk action enabled for JMEP agents only */
  get isJmepBulkActionEnabled(): boolean {
    let selectedAgents = [];
    if (this.child?.selection?.length) {
      selectedAgents = this.child?.selection.filter(item => !item.type?.name.includes('JMEP'));
    }
    return selectedAgents.length === 0;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public onClick(list: string): string {
    return list;
  }

  // eslint-disable-next-line
  tabChanged(event): void {}

  // eslint-disable-next-line
  addDevice(): void {
    this.loadNewData = false;
    this.addDeviceDialogRef = this.dialog.open(AddUnmanagedDeviceComponent, {
      width: '70rem',
      height: '71rem',
      disableClose: true,
      data: this.unManaggedDeviceData
    });
    this.addDeviceDialogRef.afterClosed().subscribe(() => {
      this.loadNewData = true;
    });
  }

  // eslint-disable-next-line
  unmanagedExportButtonLabel(): string {
    const selected = this?.unmanChild?.child?.selectedCount || 0;
    const filtered = this?.unmanChild?.child?.filteredCount() || 0;
    const all = this?.unmanChild?.allUnmanagedDevices.length || 0;
    const devicesLoadingComplete = this?.unmanChild?.devicesLoadingComplete() || false;
    return selected > 0
      ? 'Export selected'
      : devicesLoadingComplete && filtered > 0 && filtered < all
      ? 'Export filtered'
      : 'Export all';
  }
}
